import { useLayoutEffect, useRef, useState } from "react";

// Přepínač z pilulek (Dnes / Týden / Vše, záložky karet…) s klouzavým jezdcem.
// Aktivní pilulka se nepřebarví natvrdo — pod textem k ní dojede jezdec
// s lehkým dopružením a tlačítko se při stisku krátce zmáčkne.
//
// Použití: obal tlačítek místo <div className="flex … rounded-pill">,
// aktivní tlačítko dostane data-on={true} a jen barvu textu (text-white),
// pozadí kreslí jezdec. Barvu jezdce mění prop `jezdec`.
//
// varianta="podtrzeni" — záložky stránky (Nastavení, karta klienta…): místo
// pilulky klouže pod aktivní záložkou oranžová linka.
export default function Segment({ className = "", jezdec, varianta = "pilulka", children, ...rest }) {
  const linka = varianta === "podtrzeni";
  const ref = useRef(null);
  const [poz, setPoz] = useState(null);
  const [animuj, setAnimuj] = useState(false);

  const zmer = () => {
    const el = ref.current;
    if (!el) return;
    const on = el.querySelector(':scope > [data-on="true"]');
    if (!on) { setPoz(null); return; }
    const nova = { x: on.offsetLeft, y: on.offsetTop, w: on.offsetWidth, h: on.offsetHeight };
    setPoz((p) => (p && p.x === nova.x && p.y === nova.y && p.w === nova.w && p.h === nova.h ? p : nova));
  };

  // Po každém vykreslení — aktivní pilulka se mohla změnit.
  useLayoutEffect(zmer);

  // Změna velikosti (písmo, počty v závorce, otočení telefonu) — bez animace skoku.
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver(() => zmer());
    ro.observe(el);
    Array.from(el.children).forEach((c) => ro.observe(c));
    // Jezdec se poprvé ukáže na místě, animuje se až další přesun.
    const t = requestAnimationFrame(() => setAnimuj(true));
    return () => { ro.disconnect(); cancelAnimationFrame(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={ref} className={`segment relative ${className}`} {...rest}>
      {poz && (
        <span aria-hidden="true"
          className={`segment-jezdec ${linka ? "segment-linka" : ""} ${jezdec || (linka ? "bg-accent" : "bg-ink")} ${animuj ? "" : "segment-bez-animace"}`}
          style={linka
            ? { width: poz.w, height: 2, transform: `translate(${poz.x}px, ${poz.y + poz.h - 2}px)` }
            : { width: poz.w, height: poz.h, transform: `translate(${poz.x}px, ${poz.y}px)` }} />
      )}
      {children}
    </div>
  );
}
